module.exports = ".modal-body {\n  padding: 20px !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/common/double-booking/double-booking-details/double-booking-details-modal.scss
// module id = ./web/modern/components/common/double-booking/double-booking-details/double-booking-details-modal.scss
// module chunks = 0